var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _active, _drag, _abort, _isMobile, _heightObserver, _contentObserver, _containerObserver, _LayeredSlideshowComponent_instances, inactiveSize_get, setupEventListeners_fn, handleKeydown_fn, handleTabClick_fn, handleTabFocus_fn, setupPanelFocusManagement_fn, handlePanelKeydown_fn, focusPanelEdge_fn, getFocusableElements_fn, preventClickDuringDrag_fn, _handleMediaQueryChange, activate_fn, updateActiveTab_fn, updateGridSizes_fn, startDrag_fn, initializeDrag_fn, handleDrag_fn, endDrag_fn, observeContentHeight_fn, syncHeight_fn, syncDesktopHeight_fn, syncMobileHeight_fn, clearHeightStyles_fn, getMaxContentHeight_fn;
import { Component } from "@theme/component";
import { isMobileBreakpoint, mediaQueryLarge } from "@theme/utilities";
const DRAG_THRESHOLD = 5;
const MAX_DRAG_WIDTH_RATIO = 0.8;
const DRAG_COMPLETE_THRESHOLD = 0.5;
const INACTIVE_SIZE = 56;
const INACTIVE_MOBILE_SIZE = 44;
const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
class LayeredSlideshowComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _LayeredSlideshowComponent_instances);
    __publicField(this, "requiredRefs", ["container"]);
    __privateAdd(this, _active, 0);
    /** @type {DragState | null} */
    __privateAdd(this, _drag, null);
    /** @type {AbortController | null} */
    __privateAdd(this, _abort, null);
    __privateAdd(this, _isMobile, false);
    /** @type {ResizeObserver | null} */
    __privateAdd(this, _heightObserver, null);
    /** @type {MutationObserver | null} */
    __privateAdd(this, _contentObserver, null);
    /** @type {ResizeObserver | null} */
    __privateAdd(this, _containerObserver, null);
    __privateAdd(this, _handleMediaQueryChange, () => {
      const wasMobile = __privateGet(this, _isMobile);
      __privateSet(this, _isMobile, isMobileBreakpoint());
      if (wasMobile !== __privateGet(this, _isMobile)) {
        const { container } = this.refs;
        container.setAttribute("data-instant-transitions", "");
        __privateMethod(this, _LayeredSlideshowComponent_instances, clearHeightStyles_fn).call(this);
        __privateMethod(this, _LayeredSlideshowComponent_instances, observeContentHeight_fn).call(this);
        __privateMethod(this, _LayeredSlideshowComponent_instances, updateActiveTab_fn).call(this);
        __privateMethod(this, _LayeredSlideshowComponent_instances, setupEventListeners_fn).call(this);
        requestAnimationFrame(() => {
          container.removeAttribute("data-instant-transitions");
        });
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const { tabs } = this.refs;
    if (!(tabs == null ? void 0 : tabs.length)) return;
    __privateSet(this, _active, Math.max(
      0,
      tabs.findIndex((t) => t.getAttribute("aria-selected") === "true")
    ));
    __privateSet(this, _isMobile, isMobileBreakpoint());
    mediaQueryLarge.addEventListener("change", __privateGet(this, _handleMediaQueryChange));
    __privateSet(this, _containerObserver, new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          const boxSize = entry.contentBoxSize[0];
          const isMobile = __privateGet(this, _isMobile);
          let size;
          if (boxSize) {
            size = isMobile ? boxSize.blockSize : boxSize.inlineSize;
          } else {
            size = isMobile ? entry.contentRect.height : entry.contentRect.width;
          }
          __privateMethod(this, _LayeredSlideshowComponent_instances, updateGridSizes_fn).call(this, size);
        }
      }
    }));
    __privateGet(this, _containerObserver).observe(this.refs.container);
    __privateMethod(this, _LayeredSlideshowComponent_instances, updateActiveTab_fn).call(this);
    __privateMethod(this, _LayeredSlideshowComponent_instances, setupEventListeners_fn).call(this);
    __privateMethod(this, _LayeredSlideshowComponent_instances, observeContentHeight_fn).call(this);
  }
  disconnectedCallback() {
    var _a, _b, _c, _d;
    super.disconnectedCallback();
    (_a = __privateGet(this, _abort)) == null ? void 0 : _a.abort();
    (_b = __privateGet(this, _heightObserver)) == null ? void 0 : _b.disconnect();
    __privateSet(this, _heightObserver, null);
    (_c = __privateGet(this, _contentObserver)) == null ? void 0 : _c.disconnect();
    __privateSet(this, _contentObserver, null);
    (_d = __privateGet(this, _containerObserver)) == null ? void 0 : _d.disconnect();
    __privateSet(this, _containerObserver, null);
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _handleMediaQueryChange));
  }
  /**
   * Public method to select a slide by index
   * @param {number} index
   * @param {{ instant?: boolean }} [options]
   */
  select(index, { instant = false } = {}) {
    __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, index, instant);
  }
}
_active = new WeakMap();
_drag = new WeakMap();
_abort = new WeakMap();
_isMobile = new WeakMap();
_heightObserver = new WeakMap();
_contentObserver = new WeakMap();
_containerObserver = new WeakMap();
_LayeredSlideshowComponent_instances = new WeakSet();
inactiveSize_get = function() {
  return __privateGet(this, _isMobile) ? INACTIVE_MOBILE_SIZE : INACTIVE_SIZE;
};
setupEventListeners_fn = function() {
  var _a;
  (_a = __privateGet(this, _abort)) == null ? void 0 : _a.abort();
  __privateSet(this, _abort, new AbortController());
  const opts = { signal: __privateGet(this, _abort).signal };
  const { container, tabs } = this.refs;
  this.addEventListener("keydown", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, handleKeydown_fn).call(this, e), opts);
  for (const [i, tab] of tabs.entries()) {
    tab.addEventListener("click", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, handleTabClick_fn).call(this, e, i), opts);
    tab.addEventListener("focus", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, handleTabFocus_fn).call(this, e, i), opts);
  }
  __privateMethod(this, _LayeredSlideshowComponent_instances, setupPanelFocusManagement_fn).call(this, opts);
  if (!__privateGet(this, _isMobile)) {
    container.addEventListener("pointerdown", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, startDrag_fn).call(this, e), opts);
    container.addEventListener("click", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, preventClickDuringDrag_fn).call(this, e), { ...opts, capture: true });
  }
};
handleKeydown_fn = function(e) {
  var _a;
  const target = (
    /** @type {HTMLElement} */
    e.target
  );
  if (target.getAttribute("role") !== "tab") return;
  const { tabs } = this.refs;
  if (!tabs) return;
  const i = tabs.indexOf(target);
  const navMap = {
    [__privateGet(this, _isMobile) ? "ArrowUp" : "ArrowLeft"]: -1,
    [__privateGet(this, _isMobile) ? "ArrowDown" : "ArrowRight"]: 1,
    Home: -i,
    End: tabs.length - 1 - i
  };
  const offset = navMap[e.key];
  if (offset !== void 0) {
    e.preventDefault();
    const nextIndex = (i + offset + tabs.length) % tabs.length;
    (_a = tabs[nextIndex]) == null ? void 0 : _a.focus();
    __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, nextIndex);
  }
};
handleTabClick_fn = function(e, index) {
  e.preventDefault();
  __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, index);
};
handleTabFocus_fn = function(e, index) {
  const target = (
    /** @type {HTMLElement} */
    e.target
  );
  if (target.matches(":focus-visible")) {
    __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, index);
  }
};
/**
 * @param {AddEventListenerOptions & { signal: AbortSignal }} opts
 */
setupPanelFocusManagement_fn = function(opts) {
  const { panels } = this.refs;
  if (!panels) return;
  for (const [index, panel] of panels.entries()) {
    panel.addEventListener("keydown", (event) => __privateMethod(this, _LayeredSlideshowComponent_instances, handlePanelKeydown_fn).call(this, event, index), opts);
  }
};
/**
 * @param {KeyboardEvent} event
 * @param {number} index
 */
handlePanelKeydown_fn = function(event, index) {
  if (event.key !== "Tab") return;
  const { panels } = this.refs;
  const panel = (
    /** @type {HTMLElement} */
    event.currentTarget
  );
  const focusable = __privateMethod(this, _LayeredSlideshowComponent_instances, getFocusableElements_fn).call(this, panel);
  const firstFocusable = focusable[0];
  const lastFocusable = focusable[focusable.length - 1];
  if (event.shiftKey) {
    const isAtStart = firstFocusable && document.activeElement === firstFocusable || !focusable.length && document.activeElement === panel;
    if (isAtStart && index > 0) {
      event.preventDefault();
      __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, index - 1);
      __privateMethod(this, _LayeredSlideshowComponent_instances, focusPanelEdge_fn).call(this, index - 1, "end");
    }
    return;
  }
  const isAtEnd = lastFocusable && document.activeElement === lastFocusable || !focusable.length && document.activeElement === panel;
  if (isAtEnd && panels && index < panels.length - 1) {
    event.preventDefault();
    __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, index + 1);
    __privateMethod(this, _LayeredSlideshowComponent_instances, focusPanelEdge_fn).call(this, index + 1, "start");
  }
};
/**
 * @param {number} index
 * @param {'start' | 'end'} [position]
 */
focusPanelEdge_fn = function(index, position = "start") {
  var _a;
  const panel = (_a = this.refs.panels) == null ? void 0 : _a[index];
  if (!panel) return;
  const focusable = __privateMethod(this, _LayeredSlideshowComponent_instances, getFocusableElements_fn).call(this, panel);
  const target = position === "end" ? focusable[focusable.length - 1] : focusable[0];
  requestAnimationFrame(() => (target != null ? target : panel).focus());
};
/**
 * @param {HTMLElement} panel
 * @returns {HTMLElement[]}
 */
getFocusableElements_fn = function(panel) {
  return Array.from(panel.querySelectorAll(FOCUSABLE_SELECTOR)).filter((el) => !el.closest("[inert]")).map((el) => (
    /** @type {HTMLElement} */
    el
  ));
};
preventClickDuringDrag_fn = function(e) {
  var _a;
  const target = (
    /** @type {HTMLElement} */
    e.target
  );
  if (((_a = __privateGet(this, _drag)) == null ? void 0 : _a.prevent) && target.closest('[role="tab"]')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
_handleMediaQueryChange = new WeakMap();
/**
 * @param {number} index
 * @param {boolean} [instant]
 */
activate_fn = function(index, instant = false) {
  const { container, tabs } = this.refs;
  if (!tabs || index === __privateGet(this, _active) || index < 0 || index >= tabs.length) return;
  if (instant) {
    container.setAttribute("data-instant-transitions", "");
  }
  __privateSet(this, _active, index);
  __privateMethod(this, _LayeredSlideshowComponent_instances, updateActiveTab_fn).call(this);
  if (instant) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        container.removeAttribute("data-instant-transitions");
      });
    });
  }
};
updateActiveTab_fn = function() {
  var _a, _b;
  const { tabs, panels } = this.refs;
  for (const [i, tab] of (_a = tabs == null ? void 0 : tabs.entries()) != null ? _a : []) {
    const isActive = i === __privateGet(this, _active);
    tab.setAttribute("aria-selected", String(isActive));
    tab.setAttribute("tabindex", isActive ? "0" : "-1");
  }
  for (const [i, panel] of (_b = panels == null ? void 0 : panels.entries()) != null ? _b : []) {
    const isActive = i === __privateGet(this, _active);
    panel.toggleAttribute("inert", !isActive);
    panel.setAttribute("tabindex", isActive ? "0" : "-1");
    const video = panel.querySelector("video");
    if (video) {
      isActive ? video.play() : video.pause();
    }
  }
  __privateMethod(this, _LayeredSlideshowComponent_instances, updateGridSizes_fn).call(this);
};
/**
 * @param {number} [containerSize] - Override container size (used during viewport switch)
 */
updateGridSizes_fn = function(containerSize) {
  const { container, tabs } = this.refs;
  if (!tabs) return;
  const inactiveSize = __privateGet(this, _LayeredSlideshowComponent_instances, inactiveSize_get);
  const size = containerSize != null ? containerSize : __privateGet(this, _isMobile) ? container.getBoundingClientRect().height : container.getBoundingClientRect().width;
  const activeSize = size - inactiveSize * (tabs.length - 1);
  const sizes = tabs.map((_, i) => i === __privateGet(this, _active) ? "".concat(activeSize, "px") : "".concat(inactiveSize, "px"));
  container.style.setProperty("--active-tab", sizes.join(" "));
};
/**
 * @param {PointerEvent} event
 */
startDrag_fn = function(event) {
  if (__privateGet(this, _isMobile)) return;
  const { tabs } = this.refs;
  if (!tabs) return;
  const eventTarget = (
    /** @type {HTMLElement} */
    event.target
  );
  const tab = eventTarget.closest('[role="tab"]');
  if (tab) {
    const i = tabs.indexOf(
      /** @type {HTMLElement} */
      tab
    );
    if (i === __privateGet(this, _active)) return;
    const target = i > __privateGet(this, _active) ? i + 1 : i;
    if (target >= tabs.length) return;
    __privateMethod(this, _LayeredSlideshowComponent_instances, initializeDrag_fn).call(this, event, target);
  } else {
    __privateMethod(this, _LayeredSlideshowComponent_instances, initializeDrag_fn).call(this, event);
  }
};
/**
 * @param {PointerEvent} event
 * @param {number} [initialTarget]
 */
initializeDrag_fn = function(event, initialTarget) {
  const { container, tabs } = this.refs;
  if (!tabs) return;
  const containerWidth = container.getBoundingClientRect().width;
  const inactiveSize = __privateGet(this, _LayeredSlideshowComponent_instances, inactiveSize_get);
  const activeSize = containerWidth - inactiveSize * (tabs.length - 1);
  __privateSet(this, _drag, {
    target: initialTarget != null ? initialTarget : -1,
    start: event.clientX,
    max: containerWidth * MAX_DRAG_WIDTH_RATIO,
    activeSize,
    left: initialTarget !== void 0 ? initialTarget > __privateGet(this, _active) : false
  });
  const ac = new AbortController();
  const opts = { signal: ac.signal };
  document.addEventListener("pointermove", (e) => __privateMethod(this, _LayeredSlideshowComponent_instances, handleDrag_fn).call(this, e), opts);
  document.addEventListener("pointerup", () => __privateMethod(this, _LayeredSlideshowComponent_instances, endDrag_fn).call(this, ac), opts);
  document.addEventListener("pointercancel", () => __privateMethod(this, _LayeredSlideshowComponent_instances, endDrag_fn).call(this, ac), opts);
  event.preventDefault();
};
/**
 * @param {PointerEvent} event
 */
handleDrag_fn = function(event) {
  if (!__privateGet(this, _drag)) return;
  const { container, tabs } = this.refs;
  if (!container || !tabs) return;
  const delta = event.clientX - __privateGet(this, _drag).start;
  const move = Math.abs(delta);
  if (!__privateGet(this, _drag).dragging && move >= DRAG_THRESHOLD) {
    if (__privateGet(this, _drag).target === -1) {
      if (delta > 0 && __privateGet(this, _active) > 0) {
        __privateGet(this, _drag).target = __privateGet(this, _active) - 1;
        __privateGet(this, _drag).left = false;
      } else if (delta < 0 && __privateGet(this, _active) < tabs.length - 1) {
        __privateGet(this, _drag).target = __privateGet(this, _active) + 1;
        __privateGet(this, _drag).left = true;
      } else {
        return;
      }
    }
    __privateGet(this, _drag).dragging = true;
    container.setAttribute("data-dragging", "");
  }
  if (!__privateGet(this, _drag).dragging) return;
  const correct = __privateGet(this, _drag).left ? delta < 0 : delta > 0;
  const progress = correct ? Math.min(move / __privateGet(this, _drag).max, 1) : 0;
  const inactiveSize = __privateGet(this, _LayeredSlideshowComponent_instances, inactiveSize_get);
  const activeSize = __privateGet(this, _drag).activeSize;
  const range = activeSize - inactiveSize;
  const sizes = tabs.map((_, i) => {
    var _a;
    if (i === __privateGet(this, _active)) {
      const active = Math.max(inactiveSize, activeSize - range * progress);
      return "".concat(active, "px");
    }
    if (i === ((_a = __privateGet(this, _drag)) == null ? void 0 : _a.target)) {
      const drag = inactiveSize + range * progress;
      return "".concat(drag, "px");
    }
    return "".concat(inactiveSize, "px");
  });
  container.style.setProperty("--active-tab", sizes.join(" "));
  __privateGet(this, _drag).progress = progress;
};
/**
 * @param {AbortController} ac
 */
endDrag_fn = function(ac) {
  if (!__privateGet(this, _drag)) return;
  const { container } = this.refs;
  container == null ? void 0 : container.removeAttribute("data-dragging");
  if (__privateGet(this, _drag).dragging) {
    __privateGet(this, _drag).prevent = true;
    setTimeout(() => __privateSet(this, _drag, null), 100);
    if (__privateGet(this, _drag).progress && __privateGet(this, _drag).progress >= DRAG_COMPLETE_THRESHOLD) {
      __privateMethod(this, _LayeredSlideshowComponent_instances, activate_fn).call(this, __privateGet(this, _drag).target);
    } else {
      __privateMethod(this, _LayeredSlideshowComponent_instances, updateActiveTab_fn).call(this);
    }
  } else {
    __privateSet(this, _drag, null);
  }
  ac.abort();
};
observeContentHeight_fn = function() {
  var _a, _b;
  const { panels } = this.refs;
  (_a = __privateGet(this, _heightObserver)) == null ? void 0 : _a.disconnect();
  __privateSet(this, _heightObserver, new ResizeObserver(() => __privateMethod(this, _LayeredSlideshowComponent_instances, syncHeight_fn).call(this)));
  (_b = __privateGet(this, _contentObserver)) == null ? void 0 : _b.disconnect();
  __privateSet(this, _contentObserver, new MutationObserver(() => __privateMethod(this, _LayeredSlideshowComponent_instances, syncHeight_fn).call(this)));
  for (const panel of panels != null ? panels : []) {
    const content = panel.querySelector(".layered-slideshow__content");
    const inner = content == null ? void 0 : content.querySelector(".group-block-content");
    if (inner) __privateGet(this, _heightObserver).observe(inner);
    if (content) __privateGet(this, _heightObserver).observe(content);
    const target = inner != null ? inner : content;
    if (target) {
      __privateGet(this, _contentObserver).observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
  __privateMethod(this, _LayeredSlideshowComponent_instances, syncHeight_fn).call(this);
};
syncHeight_fn = function() {
  const { container } = this.refs;
  const contentHeight = __privateMethod(this, _LayeredSlideshowComponent_instances, getMaxContentHeight_fn).call(this);
  const isAuto = container.getAttribute("size") === "auto";
  if (__privateGet(this, _isMobile)) {
    __privateMethod(this, _LayeredSlideshowComponent_instances, syncMobileHeight_fn).call(this, contentHeight, isAuto);
  } else {
    __privateMethod(this, _LayeredSlideshowComponent_instances, syncDesktopHeight_fn).call(this, contentHeight, isAuto);
  }
};
/**
 * @param {number} contentHeight
 * @param {boolean} isAuto
 */
syncDesktopHeight_fn = function(contentHeight, isAuto) {
  const { container } = this.refs;
  if (isAuto) {
    let minHeightTemp = Math.max(contentHeight, 150);
    container.style.height = "".concat(minHeightTemp, "px");
    this.style.minHeight = "".concat(minHeightTemp, "px");
  } else {
    const savedMinHeight = this.style.minHeight;
    this.style.minHeight = "";
    const cssMinHeight = parseFloat(getComputedStyle(this).minHeight) || 0;
    this.style.minHeight = savedMinHeight;
    if (contentHeight > cssMinHeight) {
      this.style.minHeight = "".concat(contentHeight, "px");
      container.style.height = "".concat(contentHeight, "px");
    } else {
      this.style.minHeight = "";
      container.style.height = "";
    }
  }
};
/**
 * @param {number} contentHeight
 * @param {boolean} isAuto
 */
syncMobileHeight_fn = function(contentHeight, isAuto) {
  const { container, tabs } = this.refs;
  if (!container || !tabs) return;
  const containerStyles = getComputedStyle(container);
  const inactiveStackHeight = (tabs.length - 1) * __privateGet(this, _LayeredSlideshowComponent_instances, inactiveSize_get);
  let minPanelHeight;
  if (isAuto) {
    minPanelHeight = 150;
  } else {
    const inheritedValue = containerStyles.getPropertyValue("--layered-panel-height-mobile");
    const componentValue = getComputedStyle(this).getPropertyValue("--layered-panel-height-mobile");
    minPanelHeight = parseFloat(inheritedValue || componentValue) || 260;
  }
  const requiredActiveHeight = Math.max(minPanelHeight, contentHeight);
  container.style.setProperty("--active-panel-height", "".concat(requiredActiveHeight, "px"));
  container.style.height = "".concat(requiredActiveHeight + inactiveStackHeight, "px");
};
clearHeightStyles_fn = function() {
  const { container } = this.refs;
  this.style.minHeight = "";
  container.style.height = "";
  container.style.removeProperty("--active-panel-height");
};
getMaxContentHeight_fn = function() {
  var _a;
  const { panels } = this.refs;
  let max = 0;
  for (const panel of panels != null ? panels : []) {
    const content = panel.querySelector(".layered-slideshow__content");
    if (!content) continue;
    const inner = (
      /** @type {HTMLElement} */
      (_a = content.querySelector(".group-block-content")) != null ? _a : content
    );
    const savedHeight = inner.style.height;
    inner.style.height = "auto";
    const styles = getComputedStyle(content);
    const paddingTop = parseFloat(styles.paddingBlockStart || styles.paddingTop) || 0;
    const paddingBottom = parseFloat(styles.paddingBlockEnd || styles.paddingBottom) || 0;
    const height = (inner.scrollHeight || 0) + paddingTop + paddingBottom;
    if (height > max) max = height;
    inner.style.height = savedHeight;
  }
  return max;
};
customElements.define("layered-slideshow-component", LayeredSlideshowComponent);
export {
  LayeredSlideshowComponent
};
